module.exports = __webpack_public_path__ + "static/media/camera-icon.4f312b79.svg";